import { CustomSelect } from "@/components/CustomSelect/CustomSelect";
import GenericModal from "@/components/GenericModal/GenericModal";
import { hasStringKey } from "@/utils/misc";
import FormField from "@ingka/form-field";
import { LOCALE_MAP } from "./constants";
import Button from "@ingka/button";
import { useState } from "react";
import Text from "@ingka/text";

type Props = {
  uploadButtonLabel: string;
  languageSelectLabel: string;
  isModalOpen: boolean;
  file: File | null;
  isUploading: boolean;
  onModalClose: () => void;
  onModalUpload: (selectedLocale: string | null) => void;
};

const LocaleSelectModal = ({
  uploadButtonLabel,
  languageSelectLabel,
  isModalOpen,
  isUploading,
  file,
  onModalClose,
  onModalUpload,
}: Props) => {
  const [selectedLocale, setSelectedLocale] = useState<string | null>(null);
  const [showValidationError, setShowValidationError] = useState(false);

  const onUploadClick = () => {
    if (!selectedLocale) {
      setShowValidationError(true);
      return;
    }
    onModalUpload(selectedLocale);
    setSelectedLocale(null);
    setShowValidationError(false);
  };

  const onCloseClick = () => {
    setShowValidationError(false);
    setSelectedLocale(null);
    onModalClose();
  };

  return (
    <GenericModal
      ariaLabel="Related asset modal"
      modalType="sheets"
      size="small"
      modalVisible={isModalOpen}
      hideModal={onCloseClick}
    >
      <>
        <div className="mb-space100 flex flex-col gap-y-space100">
          <Text tagName="h2" bodySize="xl">
            {uploadButtonLabel}
          </Text>
          <Text tagName="span" className="font-bold">
            {file?.name}
          </Text>
        </div>
        <FormField
          shouldValidate={showValidationError}
          validation={{ msg: "Locale is required" }}
        >
          <label>
            {languageSelectLabel}
            <CustomSelect
              id="locale-select"
              onChange={(option) => {
                if (hasStringKey("value", option)) {
                  setShowValidationError(false);
                  setSelectedLocale(option.value);
                }
              }}
              options={Object.entries(LOCALE_MAP).map(([label, value]) => ({
                label,
                value,
              }))}
            />
          </label>
        </FormField>
        <div className="justify-left mt-space200 flex gap-x-space100">
          <Button
            type="primary"
            size="small"
            loading={isUploading}
            onClick={onUploadClick}
          >
            Save
          </Button>
          <Button size="small" onClick={onCloseClick}>
            Cancel
          </Button>
        </div>
      </>
    </GenericModal>
  );
};
export default LocaleSelectModal;
